<template>
  <div class="step-indicator">
    <span
      v-for="n in sequenceLength"
      :class="getClass(n)"
      :key="n"
      @click="navigate(n)"
    >{{ n }}</span>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 0
    },
    'sequence-length': {
      type: Number,
      default: 0
    }
  },
  methods: {
    getClass: function (n) {
      return {'active': n <= this.step + 1}
    },
    navigate: function (n) {
      this.$emit('direct-navigate', n)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/library/step-indicator.vue